import { ActorRefFrom, SnapshotFrom } from 'xstate';
import { createDesignerStateMachine } from './AllocationDesigner.state';
import { createFilterMachine } from './AllocationSelectionFilter.state';

export const eventFilterMachine = createFilterMachine('event-filter');
export type EventFilterSnapshotType = SnapshotFrom<typeof eventFilterMachine>;
export type EventFilterSendType = ActorRefFrom<typeof eventFilterMachine>['send'];

export const projectFilterMachine = createFilterMachine('project-filter');
export type ProjectFilterSnapshotType = SnapshotFrom<typeof projectFilterMachine>;
export type ProjectFilterSendType = ActorRefFrom<typeof projectFilterMachine>['send'];

export const externalEventFilterMachine = createFilterMachine('external-event-filter');
export type ExternalEventFilterSnapshotType = SnapshotFrom<typeof externalEventFilterMachine>;
export type ExternalEventFilterSendType = ActorRefFrom<typeof externalEventFilterMachine>['send'];

export const designerStateMachine = createDesignerStateMachine();
export type DesignerStateSendType = ActorRefFrom<typeof designerStateMachine>['send'];
